import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  LoginLiffRequest,
  LoginLineRequest,
  LoginPhoneRequest,
  PhoneStatusRequest,
  PhoneStatusResponse,
} from '@aiii/nn-types/functions/login';

interface FirebaseCustomTokenResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient) {}

  /**
   * 執行 LIFF 登入
   * @param body 表單內容
   * @returns Account Token
   */
  public async loginLiff(body: LoginLiffRequest): Promise<string> {
    const accountToken: string = await lastValueFrom(
      this.http.post(environment.api.login.loginLiff, body, { responseType: 'text' })
    );
    localStorage.setItem('token', accountToken);

    return accountToken;
  }

  /**
   * 執行 LINE 登入
   * @param body 表單內容
   * @returns Account Token
   */
  public async loginLine(body: LoginLineRequest): Promise<string> {
    const accountToken: string = await lastValueFrom(
      this.http.post(environment.api.login.loginLine, body, { responseType: 'text' })
    );
    localStorage.setItem('token', accountToken);

    return accountToken;
  }

  /**
   * 執行手機號碼登入
   * @param body 表單內容
   * @returns Account Token
   */
  public async loginPhone(body: LoginPhoneRequest): Promise<string> {
    const accountToken: string = await lastValueFrom(
      this.http.post(environment.api.login.loginPhone, body, { responseType: 'text' })
    );
    localStorage.setItem('token', accountToken);

    return accountToken;
  }

  /**
   * 以既有的 Account token 換取 nn-platform Firebase Custom Token。
   * AuthHttpInterceptor 會自動附上 Account token 的 Bearer header。
   */
  public async getFirebaseCustomToken(): Promise<string> {
    const response = await lastValueFrom(
      this.http.post<FirebaseCustomTokenResponse>(environment.api.login.firebaseCustomToken, {})
    );
    return response.token;
  }

  /**
   * 根據手機驗證結果判斷 App phone 註冊分流
   */
  public async getPhoneStatus(body: PhoneStatusRequest): Promise<PhoneStatusResponse> {
    return (await lastValueFrom(
      this.http.post(environment.api.login.phoneStatus, body, { responseType: 'text' })
    )) as PhoneStatusResponse;
  }
}
